import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class DateModule {
    /* Currently our application only uses EST time zone - other timezones are added just for expansion if we need to do in the future. */
    private timeZones = {
        'EST' : 'America/New_York',
        'MST' : 'America/Denver',
        'IST' : 'Asia/Calcutta'
    };

    constructor() {}

    getDate(date: Date = new Date()) {
        //Hardcoded EST time for now - If we want to apply different timezones for different customers then we can move this to config file accordingly.
        return this.convertTimeZone(date, this.timeZones['EST']);
    }

    convertTimeZone(date: Date, timeZone: string) {
        return new Date(date.toLocaleString('en', {timeZone}));
    }
}
